var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarplus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0v80h80V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0v80h80V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.337 37.626a.193.193 0 0 1-.184.132h-7.601l6.158 4.413a.19.19 0 0 0 .215.007c1.703-1.045 3.193-1.77 6.36-2.588 0 0-4.86 3.591-8.041 7.615a.899.899 0 0 0-.158.293l-.662 2.012 6.15-4.408a.19.19 0 0 1 .227 0l6.15 4.408-2.349-7.134a.186.186 0 0 1 .07-.212l6.15-4.408h-7.6a.193.193 0 0 1-.184-.132l-2.349-7.133-2.352 7.135Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 39.259h-4.793V34.53h-2.543v4.729h-4.79v2.436h4.79v4.728h2.543v-4.728H74v-2.436Zm-20.702-3.35c1.243 0 2.037.637 2.037 1.691 0 1.102-.794 1.887-2.037 1.887H51.31V35.91h1.987Zm1.564 6.077c2.135-.269 3.9-2.083 3.9-4.386 0-2.989-2.062-4.63-5.39-4.63h-5.44v15.046h3.379V42.06l4.048 5.955h3.924l-4.421-6.03Zm-27.069-9.019h-10.06v3.039h3.305v12.008h3.453V36.006h3.304v-3.039h-.002Zm-16.414 5.516c-.968-.442-1.341-.907-1.341-1.52 0-.71.621-1.3 1.54-1.274.844.024 1.465.465 1.937 1.52l2.905-1.25c-.794-2.01-2.41-3.186-5.017-3.186-2.757 0-4.794 1.789-4.794 4.19 0 1.642.794 2.99 2.831 3.994l2.037 1.005c1.143.564 1.689.981 1.689 1.814 0 .883-.746 1.52-1.689 1.52-1.018 0-1.936-.564-2.36-1.838l-3.08.882c.696 2.475 2.758 3.921 5.44 3.921 2.906 0 5.142-1.838 5.142-4.485 0-2.033-1.093-3.406-3.305-4.411l-1.935-.883Z",
    fill: "#261E3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 27.475,
    y1: 50.811,
    x2: 45.488,
    y2: 32.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA1660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FA1660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF6E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6E00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarplus);
export default __webpack_public_path__ + "static/media/starplus.cb61ce28350b6f8a4a63eb5d4eaf65ea.svg";
export { ForwardRef as ReactComponent };